import SendAdvancingRequest from "./sendAdvancingRequest";
import React from "react";
import Modal from "components/modal";
import { useQueryClient } from "@tanstack/react-query";
import { useCustomQuery } from "utilities/hookutils";
import QueryPagination from "pagination/components/querypagination";
import Panel from "components/panels/panel";
import AdvancingRowCard from "advancingapprove/list/AdvancingRowCard";
import { useShortcutPanel } from "components/Shortcuts/hooks";
import { ButtonSecondary } from "components/Atoms/Button";
interface Props {
  showId: number
  config: server.dto.AdvancingInShowPanelConfig
}

const AdvancingApproveForShowDetail = (props: Props) => {
  const [showNewModal, setShowNewModal] = React.useState(false);

  const queryClient = useQueryClient();

  const onCreatedAdvancing = () => {
    setShowNewModal(false);
    queryClient.invalidateQueries({ queryKey: ["advancingList"] });
  };

  const maxPerPage = 10;

  const [instruction, setInstruction] = React.useState<server.dto.ListAdvancingForShowInstruction>({
    page: 1,
    perPage: maxPerPage,
    showIds: [props.showId]
  });

  const advancingQuery = useCustomQuery({
    queryKey: ["advancingList", instruction],
    queryFn: async () => window.CoreApi.Advancing.ListForShow(instruction).then(r => r.data),
    cacheTime: 0,
    keepPreviousData: true
  });

  const { refToScrollTo } = useShortcutPanel({
    type: "advancing",
    label: props.config.headerLabel,
    totalItems: advancingQuery.data?.data?.length || 0,
    onAddClicked: props.config.canAdd ? () => { setShowNewModal(true); } : undefined
  });

  return <>
    <Modal
      isOpen={showNewModal}
      handleClose={() => { setShowNewModal(false); }}
      title={RESX.Advancing.InviteSomeone}
      minHeight={400}
      width="small"
    >
      <SendAdvancingRequest
        showId={props.showId}
        onFinishSending={onCreatedAdvancing}
      />
    </Modal>
    <Panel
      panelClassName="s1_related-feature-panel"
      panelRef={refToScrollTo}
      title={props.config.headerLabel}
      pagination={<QueryPagination
        page={instruction.page}
        onPageChanged={page => { setInstruction(prev => ({ ...prev, page })); }}
        query={advancingQuery}
      />}
      hasData={advancingQuery.data?.data.length > 0}
      isLoading={advancingQuery.data == null}
      hasError={advancingQuery.isError}
      articleId={serverReference.supportArticleIds.whatIsAdvancing}
      button={props.config.canAdd && <ButtonSecondary onClick={() => { setShowNewModal(true); }} label={RESX.Advancing.InviteSomeone} />}
    >
      <div className="list-with-gaps card-layout advancing-list">
        <div className="list-with-gaps-body">
          {advancingQuery.data?.data.map(row => (
            <AdvancingRowCard key={row.advancingId} item={row} />
          ))}
        </div>
      </div>
    </Panel>
  </>;
};

export default AdvancingApproveForShowDetail;
